import { useSelector } from 'react-redux';
/** The selector function without useSelect applied for analytic functions */
export const analyticFunctionSelector = (state) => state.analyticFunctions;
/** The applied analytic functions selector */
export const useSelectAnalyticFunctions = () => useSelector(analyticFunctionSelector);
// legacy exports (incorrect hook shape)
export const selectAnalyticFunctions = useSelectAnalyticFunctions;
